import { gql } from '@apollo/client'

export default gql(`
    mutation transferAssets($input: TransferAssetInput!, $type: String, $project: String) {
        transferAssets(
            input: $input,
            type: $type
            project: $project
        )
    }`
)
